import { motion } from "framer-motion";
import { X, Check } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { useContent } from "../../lib/content";

const Strike = ({ children, delay }) => (
  <span className="relative inline-block">
    {children}
    <motion.span className="absolute left-0 top-[55%] h-[0.09em] bg-[#ff5500] origin-left w-full"
      initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }} />
  </span>
);

const ManifestoTitle = ({ text }) => {
  const [first, ...rest] = String(text).split(". ");
  const words = first.split(" ");
  const last = words.pop();
  return (
    <h2 data-testid="manifesto-title" className="font-display font-extrabold text-white text-3xl sm:text-5xl lg:text-6xl leading-[1.02]">
      {words.join(" ")} <Strike delay={0.5}>{last}{rest.length ? "." : ""}</Strike>
      {rest.length > 0 && <span className="block mt-3 text-frost-grad">{rest.join(". ")}</span>}
    </h2>
  );
};

const List = ({ items, good }) => (
  <ul className="space-y-3">
    {(items || []).map((t, i) => (
      <Reveal key={i} delay={0.08 * i} y={14} as="li"
        className={`flex items-center gap-3 text-[15px] ${good ? "text-white" : "text-slate-400 line-through decoration-slate-600"}`}>
        <span className={`shrink-0 w-6 h-6 grid place-items-center rounded-md ${good ? "bg-[#ff5500] text-white" : "bg-white/5 text-slate-400"}`}>
          {good ? <Check className="w-3.5 h-3.5" /> : <X className="w-3.5 h-3.5" />}
        </span>{t}
      </Reveal>
    ))}
  </ul>
);

export const Manifesto = () => {
  const h = useContent().home;
  return (
    <section id="programma" data-testid="manifesto-section" className="relative py-24 sm:py-32 lg:py-40">
      <div className="absolute left-1/2 top-0 -translate-x-1/2 w-[70%] h-px bg-gradient-to-r from-transparent via-[#ff5500]/50 to-transparent" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-10">
        <div className="lg:col-span-7">
          <Reveal><SectionLabel index="01" tone="heat">{h.manifesto_label}</SectionLabel></Reveal>
          <Reveal delay={0.1} className="mt-7"><ManifestoTitle text={h.manifesto_title} /></Reveal>
          <Reveal delay={0.2}><p className="mt-8 max-w-xl text-base sm:text-lg text-slate-300 leading-relaxed">{h.manifesto_text}</p></Reveal>
        </div>
        <div className="lg:col-span-5 lg:pt-16 grid sm:grid-cols-2 lg:grid-cols-1 gap-4">
          <Reveal className="rounded-2xl border hairline bg-white/[0.02] p-6">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 mb-5">Agenzia tradizionale</p>
            <List items={h.manifesto_not} />
          </Reveal>
          <Reveal delay={0.12} className="relative rounded-2xl p-6 glass overflow-hidden">
            <div className="absolute -right-16 -top-16 w-48 h-48 rounded-full bg-[#ff5500]/20 blur-3xl" />
            <p className="relative font-mono text-[11px] uppercase tracking-[0.2em] text-[#ff8a4c] mb-5">Programma TERMONLINE</p>
            <div className="relative"><List items={h.manifesto_yes} good /></div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
